$(() => {
    URI.init();

    // Search
    $('#search-btn').click(function () {
        let search: any = $('#search').val();
        if (search.length > 2) {
            window.location.href = '/#/busca/' + encodeURIComponent(search);
        }
    });

    $('#search').keyup(function (event: any) {
        if (event.keyCode == 13) {
            $('#search-btn').click();
        }
    });

    $('#search-btn-m').click(function () {
        let search: any = $('#search-m').val();
        if (search.length > 2) {
            window.location.href = '/#/busca/' + encodeURIComponent(search);
        }
    });

    //PopUP's
    if ($('#popupModal').length === 1) {
        (<any>$('#popupModal')).modal('show');

        $('#popupModal').on('hidden.bs.modal', function () {
            let iframe = $('#popupModal iframe');
            iframe.remove();
        });
    }

    var navMain = $('.navbar-collapse');
    navMain.on('click', 'a:not([data-toggle])', null, function () {
        navMain.collapse('hide');
    });
});
